import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from "react-router-dom";
import { getsitesbycompanyid } from '../../Redux/Actions/SiteActions';
import { Modal, Carousel } from "react-bootstrap";
import { getallcompanies } from '../../Redux/Actions/CompanyActions';
import { Select, Input } from 'antd';
import { fetchSitesByCompanyId, fetchAllWorkdata, fetchProjectDetails, fetchUsersDetails,fetchSubCompaniesByUserId } from "../../Redux/Api/fetch.api";
import { getusersandroles } from '../../Redux/Actions/UsersActions';
import { getsubcompanybyuserid } from '../../Redux/Actions/UserCompanyAction';
import { getallusers } from '../../Redux/Actions/UsersActions';
import { getallprojects } from '../../Redux/Actions/AccessibilityActions';
import { getworkcategory } from '../../Redux/Actions/WorkItemAction';
import PhoneInput from 'react-phone-input-2'
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import axios from "axios";
import * as url from "../../api/uri_helper";
import SupportUploadImage from "../Support/SupportUploader";
import Loader from "../loader";
import heic2any from 'heic2any';
const RequestTypeEnum = Object.freeze({
    LiveChat: 0,
    Audio: 1,
    Video: 2,
    Email: 3,
    Whatsapp: 4,
    SMS: 5
});


   
   
const AddSupport = ({ showSupportModal, handleShowModalClose }) => {
    const dispatch = useDispatch();
    const [userId, setUserId] = useState();
    const [companyId, setCompanyId] = useState(0);
    const [siteId, setSiteId] = useState();
    const [projectId, setProjectId] = useState();
    const [requestId, setRequestId] = useState(0);
    const [categoryId, setCategoryId] = useState();
    const [sitesData, setSitesData] = useState([]);
    const [companyError, setCompanyError] = useState(false);
    const [filteredSupportOptions, setFilteredSupportOptions] = useState([]);
    const [filteredSiteOptions, setFilteredSiteOptions] = useState([]);
    const [filteredUserOptions, setFilteredUserOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [allSubCompanies, setAllSubCompanies] = useState([]);
    const loggedUserId = localStorage.getItem('UserId')
    const [allAppData, setAllAppData] = useState([]);
    const [allWorkCategory, setAllWorkCategory] = useState([])
    const [phnumber, setPhnumber] = useState("");
    const [selectedUserEmail, setSelectedUserEmail] = useState("");
    const [phoneError, setPhoneError] = useState(false);
    const [selectedCountryCode, setSlectedCountryCode] = useState()
    const [description, setDescription] = useState("");
    const [count, setCount] = useState(0);
    const [images, setImages] = useState({
        upload: {
            pictures: [],
            maxFileSize: 5242880,
            imgExtension: [".jpg", ".png", ".jpeg"],
            defaultImages: [
            ],
        },
    });
   
    const [allUploadedFiles, setAllUploadedFiles] = useState([]);
    let uploadedFileNames;
    const [heicFile, setHeicFile] = useState(false);
    let fileTypeId;
    const [imageName, setImageName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    console.log("requestid", requestId)
   
   // const [uploadedChatBotImage, setUploadedChatBotImage] = useState([]);
  
   

    useEffect(() => {
        getusers();
        getallapps();
        getallworkdata();
    }, []);
   
   

    useEffect(() => {
        if (userId > 0) {           
            getSubCompaniesDetails();
        }
    }, [userId]);

    useEffect(() => {
        if (companyId > 0) {           
            getCompanysiteDetails();
        }
    }, [companyId]);

   
    const getSubCompaniesDetails = () => {
        fetchSubCompaniesByUserId(userId)
            .then(response => {
             
                dispatch(getsubcompanybyuserid(response.data))
                setAllSubCompanies(response.data.data.companyUserdata)
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const getallapps = () => {

        setLoading(true)
        fetchProjectDetails()
            .then(response => {
                dispatch(getallprojects(response.data))
                setAllAppData(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
        setLoading(false)
    }

    useEffect(() => {
        if (userId) {
            const selectedUser = allUsers.find(user => user.userId === userId);
            setSelectedUserEmail(selectedUser ? selectedUser.emailId : '');
        }
    }, [userId]);

    const getusers = () => {

        fetchUsersDetails()
            .then(response => {
               
                dispatch(getallusers(response.data))
                setAllUsers(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const getallworkdata = () => {
        setLoading(true)
        fetchAllWorkdata()
            .then(response => {
                dispatch(getworkcategory(response.data))
                setAllWorkCategory(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
       
        setLoading(false)
       
    }

    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    const AddSupportData = async () => {
      
        const formData = new FormData();
        if (!userId) {           
                toast.error("Please select User", {
                    className: "toastSuccess",
                });
                setLoading(false);
                return;           
        } 

        if (!companyId) {
            toast.error("Please select Company", {
                className: "toastSuccess",
            });
            setLoading(false);
            return;
        } 

        if (!siteId) {
            toast.error("Please select Site", {
                className: "toastSuccess",
            });
            setLoading(false);
            return;
        } 

        if (!projectId) {
            toast.error("Please select project", {
                className: "toastSuccess",
            });
            setLoading(false);
            return;
        }

        if (requestId === 1 || requestId === 4 || requestId === 5 || requestId == undefined) {
            const actualNumber = phnumber.replace(/^\+\d+/, '').trim(); // Extract actual number

            if (!actualNumber || actualNumber.length < 10 || actualNumber.startsWith('0')) {
                setPhoneError(true);
                return;
            }
        }
        //if (requestId === 1 || requestId === 4 || requestId === 5 || requestId == undefined) {
        //    if (!phnumber || !(phnumber && phnumber.length > 10)) {
              
        //        setPhoneError(true);
        //        return;
        //    }
        //}

        if (!description) {
            toast.error("Please enter description", {
                className: "toastSuccess",
            });
            setLoading(false);
            return;
        }
       
        uploadedFileNames = new Set();
        if (!Array.isArray(allUploadedFiles)) {
            console.error('allUploadedFiles is not an array');
            return;
        }
        allUploadedFiles && allUploadedFiles.forEach((fileObj, index) => {

            if (fileObj.Extension === '.heic') {

                const _fileData = new File([fileObj.AttachmentFile], fileObj.AttachmentFile.name);
                if (!uploadedFileNames.has(_fileData.name)) {
                    setImageName(_fileData.name);
                    formData.append(`SupportAttachments[${index}].AttachmentFile`, _fileData);
                    formData.append(`SupportAttachments[${index}].FileTypeId`, fileObj.FileTypeId);
                    uploadedFileNames.add(_fileData.name);
                }
                setHeicFile(false);
            } else if (fileObj.Extension === '.jpg' || fileObj.Extension === '.jpeg' || fileObj.Extension === '.png' || fileObj.Extension === '.gif' || fileObj.Extension === '.svg') {

                const imageUrl = fileObj.AttachmentFile.split(";");
                var contentType = imageUrl[0].split(":")[1];
                var realData = imageUrl[2].split(",")[1];
                var blob = b64toBlob(realData, contentType);
                const _fileData = new File([blob], imageUrl[1].substring(5));
                if (!uploadedFileNames.has(_fileData.name)) {
                    setImageName(_fileData.name);
                    formData.append(`SupportAttachments[${index}].AttachmentFile`, _fileData);
                    formData.append(`SupportAttachments[${index}].FileTypeId`, fileObj.FileTypeId);
                    uploadedFileNames.add(_fileData.name);
                }
            } 
        })
        setLoading(true)
        formData.append("EmailId", selectedUserEmail);
        formData.append("CompanyId", companyId);
        formData.append("SiteId", siteId);
        formData.append("appID", projectId);
        if (phnumber || requestId == 1 || requestId == 4 || requestId == 5 || requestId == undefined) {
           
            formData.append("PhoneNumber", phnumber);
        }
        const requestTypeKey = Object.keys(RequestTypeEnum).find(key => RequestTypeEnum[key] === requestId);
        formData.append("RequestType", requestTypeKey || "LiveChat"); 
       
        formData.append("IsCallRequest", requestId == 1 || requestId == 4 || requestId == 5 || requestId == undefined ? true : false);
        
        if (categoryId !== null && categoryId !== undefined) {
            formData.append("CategoryId", categoryId);
        }
        formData.append("Description", description);
        formData.append("FileTypeId", 1);
       
        const response_ = await axios({
            method: 'post',
            url: url.ADD_SUPPORTDATA,
            data: formData,
        }).then(response => {
           
            if (response.data.success) {
                toast.success("Support request added successfully", {
                    className: "toastSuccess",
                });
                uploadedFileNames.length = 0;
                setAllUploadedFiles([]);
                setImages([]);
                setPhnumber("")
                setCategoryId("");
                setCompanyId("")
                setUserId("")
                setSiteId("")
                setProjectId("")
                setDescription("")
               // setUploadedChatBotImage([]);
                handleShowModalClose();
               
               
               
            } else {
                toast.error(`${response.data.message}`, {
                    className: "toastError",
                });

            }
            setLoading(false)
        })
    }

    const getCompanysiteDetails = () => {
        fetchSitesByCompanyId(companyId)
            .then(response => {
                dispatch(getsitesbycompanyid(response.data))
                setSitesData(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            })
    }

    const handleInputForUserDropdown = (input) => {

        const filtered = allUsers && allUsers.filter(item => {
            const fullName = `${item.lastName} ${item.firstName}`;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredUserOptions(filtered);
    };

    const Requestdata = [
        {
            key: '1',
            id: 1,
            name: 'Call',
        },
        {
            key: '2',
            id: 2,
            name: 'Email',
        },       
    ];
   
   
    const handleInputForSupportDropdown = (input) => {

        const filtered = allSubCompanies && allSubCompanies.filter(item => {
            const fullName = item.subCompanyName;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredSupportOptions(filtered);
    };

    const handleInputForSiteDropdown = (input) => {

        const filtered = sitesData && sitesData.filter(item => {
            const fullName = item.siteName;
            return fullName.toLowerCase().includes(input.toLowerCase());
        });
        setFilteredSiteOptions(filtered);
    };

    function base64ToBinary(base64) {
        const binaryString = atob(base64);
        const length = binaryString.length;
        const bytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    function calculateImageSize(base64) {
       
        const binaryData = base64ToBinary(base64);
        const fileSizeInBytes = binaryData.length;
        const fileSizeInKB = fileSizeInBytes / 1024; // Convert bytes to kilobytes
        const fileSizeInMB = fileSizeInKB / 1024; // Convert kilobytes to megabytes

        return {
            bytes: fileSizeInBytes,
            kilobytes: fileSizeInKB,
            megabytes: fileSizeInMB
        };
    }

    const handleFileType = (fileTypeExtension) => {
        if (fileTypeExtension === '.jpg' || fileTypeExtension === '.jpeg' || fileTypeExtension === '.png' || fileTypeExtension === '.gif' || fileTypeExtension === '.svg' || fileTypeExtension === '.heic') {
            fileTypeId = 1
        }              
        return fileTypeId
    }

    const handleImagesChange = async (files) => {
        
        //setAttacmentOptionsDisplay(false);
        const uploadedFilesWithExtensions = [];
        let newUrl, newBlob;
        if (!files || files.length === 0) {
          //  setAttacmentOptionsDisplay(false);
            setErrorMessage("Select only '.jpg', '.jpeg','.svg', '.png', '.gif', 'heic' files.");
            setTimeout(() => {
                setErrorMessage('');
            }, 5000);
            return;
        }
        let extension = '';
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.type && file.type.startsWith('image/')) {
                extension = '.' + file.type.split('/')[1];
            } else if (file.name) {
                const filename = file.name;
                const match = filename.match(/\.([^.]+)$/);
                if (match && match.length > 1) {
                    extension = '.' + match[1].toLowerCase();
                }
            }

            // Check if it's a data URI
            const dataUriIndex = file.indexOf('data:');
            if (dataUriIndex === 0) {
                const nameIndex = file.indexOf('name=', dataUriIndex);
                if (nameIndex > -1) {
                    const semicolonIndex = file.indexOf(';', nameIndex);
                    if (semicolonIndex > -1) {
                        const nameSubstring = file.substring(nameIndex, semicolonIndex);
                        const dotIndex = nameSubstring.lastIndexOf('.');
                        if (dotIndex > -1) {
                            extension = nameSubstring.substring(dotIndex);
                        }
                    }
                }
            }

            const base64String = file.split(';base64,')[1];
            const size = calculateImageSize(base64String);
            const allowedExtensions = ['.jpg', '.jpeg', '.svg', '.png', '.gif', 'heic'];

            if (size.megabytes > 5) {
                
                setImages('');

                setErrorMessage("Image size exceeds 5MB.");
                setImages('');
                setTimeout(() => {
                    setErrorMessage('');
                }, 5000);
                return;
            }
            else {
               
                if (extension === '.heic') {
                   
                    setLoading(true);
                    const semicolonIndex = file.indexOf(';');
                    try {
                      
                        if (semicolonIndex !== -1) {
                            const response = await fetch(file);
                            const blob = await response.blob();
                            const conversionResult = await heic2any({ blob });
                            const url = URL.createObjectURL(conversionResult);
                            const filename = file.split(';')[1].split('=')[1];
                            const newFilename = filename.replace('.heic', '.jpeg');
                            newBlob = new Blob([conversionResult], { type: 'image/jpeg' });
                            newBlob.name = newFilename;
                            newUrl = URL.createObjectURL(newBlob);
                            setHeicFile(true);
                            //setUploadedChatBotImage(prevImages => [...prevImages, newUrl]);
                          
                            setImages({
                                ...images,
                                upload: {
                                    ...images.upload,
                                    pictures: [...images.upload.pictures, newBlob],
                                },
                            });
                        }
                    } catch (error) {
                        console.log(error);
                    } finally {
                        setLoading(false);
                    }
                }
                else {
                    const blob = file;
                   // setUploadedChatBotImage(prevImages => [...prevImages, newUrl]);
                    setImages({
                        ...images,
                        upload: {
                            ...images.upload,
                            pictures: [...images.upload.pictures, blob],
                        },
                    });
                }
            }

            if (!Array.isArray(allUploadedFiles)) {
                console.error('allUploadedFiles is not an array');
                return;
            }


            if (extension !== '.heic') {
                if (allUploadedFiles && !allUploadedFiles.some(existingFile => existingFile.AttachmentFile === file)) {
                    const fileType = handleFileType(extension);
                    uploadedFilesWithExtensions.push({ AttachmentFile: file, FileTypeId: fileType, Extension: extension });
                }
            }
            else {
                if (allUploadedFiles && !allUploadedFiles.some(existingFile => existingFile.AttachmentFile === newBlob)) {
                    //  extension = '.heic';
                    const fileType = handleFileType(extension);
                    uploadedFilesWithExtensions.push({ AttachmentFile: newBlob, FileTypeId: fileType, Extension: extension });
                }
            }
        }
        setAllUploadedFiles(prevFiles => [...prevFiles, ...uploadedFilesWithExtensions]);
    };

    const handlePhoneChange = (phone, country) => {
        setSlectedCountryCode(country.countryCode);

        // Update phone number
        setPhnumber(phone);

        // Extract actual number (excluding country code)
        const actualNumber = phone.replace(`+${country.dialCode}`, '').trim();

        // Clear validation if the number is valid
        if (actualNumber.length >= 10 && !actualNumber.startsWith('0')) {
            setPhoneError(false);
        }
    };


   
    return (
        <>
           
            <Modal
                show={showSupportModal}
                onHide={handleShowModalClose}
                backdrop="static"
                keyboard={false}              
                size='xl'
            >
                {loading && (
                    <div className="modal-loader-container">
                        <Loader />
                    </div>
                )}
                <Modal.Header closeButton>
                    <Modal.Title className="p-0">Add Support Request</Modal.Title>
                </Modal.Header>
             
                <Toaster />
                <Modal.Body>
                   
                    <div class="add-support-model">
                            <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                        <label>Requested By <span className="required-fields"> * </span></label>
                                      
                                        <Select className="w-100"
                                        aria-label=".form-select-lg example"
                                        placeholder="Select User"
                                        showSearch
                                        value={userId}
                                        onChange={(value) => {
                                            setUserId(value)
                                            setCompanyId("")
                                        }}
                                        onSearch={(value) => {
                                            handleInputForUserDropdown(value)
                                        }}
                                        filterOption={false}
                                    >
                                        {filteredUserOptions.length > 0 ?
                                            filteredUserOptions && filteredUserOptions.map(item =>
                                                <Option key={item.userId} value={item.userId}>
                                                    {`${item.lastName} ${item.firstName}`}
                                                </Option>
                                            )
                                            :
                                            allUsers && allUsers.map(item =>
                                                <Option key={item.userId} value={item.userId}>
                                                    {`${item.lastName} ${item.firstName}`}
                                                </Option>
                                            )
                                        }

                                            </Select>
                                   


                                </div>
                                </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Company <span className="required-fields"> * </span></label>
                                    <Select className="w-100"
                                        aria-label=".form-select-lg example"
                                        placeholder="Select Company"
                                        showSearch
                                        value={companyId || undefined}
                                            onChange={(value) => {                                               
                                                setCompanyId(value)
                                                setSiteId("")
                                        }}
                                        onSearch={(value) => {
                                            handleInputForSupportDropdown(value)
                                        }}
                                        filterOption={false}
                                       // style={{ width: 250 }}
                                    >
                                        {filteredSupportOptions.length > 0 ?
                                            filteredSupportOptions && filteredSupportOptions.map(item =>
                                                <Option key={item.subCompanyId} value={item.subCompanyId}>
                                                    {item.subCompanyName}
                                                </Option>
                                            )
                                            :
                                            allSubCompanies && allSubCompanies.map(item =>
                                                <Option key={item.subCompanyId} value={item.subCompanyId}>
                                                    {item.subCompanyName}
                                                </Option>
                                            )
                                        }

                                    </Select>


                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Site <span className="required-fields"> * </span></label>
                                    <Select className="w-100"
                                        aria-label=".form-select-lg example"
                                        placeholder="Select Site"
                                        showSearch
                                            value={siteId || undefined} 
                                        onChange={(value) => {
                                            setSiteId(value)
                                        }}
                                        onSearch={(value) => {
                                            handleInputForSiteDropdown(value)
                                        }}
                                        filterOption={false}
                                       // style={{ width: 250 }}
                                    >
                                        {filteredSiteOptions.length > 0 ?
                                            filteredSiteOptions && filteredSiteOptions.map(item =>
                                                <Option key={item.siteId} value={item.siteId}>
                                                    {item.siteName}
                                                </Option>
                                            )
                                            :
                                            sitesData && sitesData.map(item =>
                                                <Option key={item.siteId} value={item.siteId}>
                                                    {item.siteName}
                                                </Option>
                                            )
                                        }

                                    </Select>
                                   
                                </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Project <span className="required-fields"> * </span></label>
                                        <Select className="w-100"
                                            aria-label=".form-select-lg example"
                                            placeholder="Select Project"                                           
                                            defaultValue={projectId}
                                            onChange={(value) => {
                                                setProjectId(value)
                                            }}
                                        >
                                            {allAppData && allAppData.map(project =>
                                               // project.dashBoardUrl != null ?
                                                    <Option key={project.appId} value={project.appId} >
                                                        {project.name}
                                                    </Option>
                                                  //  : ""
                                            )}
                                            

                                        </Select>
                                       
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Category </label>
                                        <Select className="w-100"
                                            aria-label=".form-select-lg example"
                                            placeholder="Select Category"
                                            defaultValue={categoryId}
                                            onChange={(value) => {
                                                setCategoryId(value)
                                            }}


                                           // style={{ width: 220 }}
                                        >
                                            {allWorkCategory && allWorkCategory.map(project =>
                                              
                                                <Option key={project.workCategoryId} value={project.workCategoryId} >
                                                    {project.workDescription}
                                                    </Option> 
                                            )}


                                        </Select>
                                       
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Request Type </label>
                                        <Select className="w-100"
                                            aria-label=".form-select-lg example"
                                            placeholder="Select Request Type"
                                            defaultValue={0} 
                                            onChange={(value) => {
                                                setRequestId(value)
                                            }}


                                           // style={{ width: 220 }}
                                        >
                                        {Object.entries(RequestTypeEnum).map(([key, value]) => (
                                            <Option key={value} value={value}>
                                                {key} {/* Displaying the key as the name */}
                                            </Option>
                                        ))}


                                        </Select>

                                    </div>
                                </div>

                            {requestId == 1 || requestId == 4 || requestId == 5  ?
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Phone Number <span className="required-fields"> * </span></label>
                                            <div className="input-group phnumber">
                                            <PhoneInput
                                                className="w-100"
                                                country={"us"}
                                                enableSearch={true}
                                                value={phnumber}
                                                onChange={handlePhoneChange}
                                            />


                                            </div>
                                            {< small className="text-danger d-block mt-2">{!phoneError ? ' ' : "Please enter valid phone number"}</small>}
                                        </div>
                                    </div> : ""
                                }

                                <div className="col-md-8">
                                    <div className="form-group">
                                        <label>Description <span className="required-fields"> * </span></label>
                                        <div className="input-group">
                                            <textarea className="form-control" placeholder="Enter Description" maxLength="250"

                                                onChange={(e) => {
                                                    setCount(e.target.value.length);
                                                    setDescription(e.target.value.replace(/\s+/g, ' '))
                                                }}></textarea>
                                            {/*<Input */}
                                            {/*    type="textarea" */}
                                              
                                            {/*/>*/}
                                            <small className="count text-left">{count}/250</small>
                                          
                                        </div>
                                    </div>
                                </div>

                                
                          </div>                            
                                             
                                <SupportUploadImage
                                    handleChange={handleImagesChange}
                                    defaultImages={[]}
                                    pictures={[]}
                                    buttonText={"Upload Media"}
                                    images={false}
                        />    
                      
                    </div>

                   
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary mr-3" onClick={AddSupportData}
                        disabled={!userId || !companyId || !siteId || !projectId || !description}
                    >Save</button>
                    <button className="btn btn-primary" type="button" onClick={handleShowModalClose}>
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal>
        </>

    );
}

export default AddSupport;
